import axios from "axios";

// Use same-origin for API calls so both preview and production work without CORS.
// (Both environments serve /api on the same domain as the frontend.)
const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const winOrigin = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = winOrigin || envUrl;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
